import { render, staticRenderFns } from "./CarSizeTypeView.vue?vue&type=template&id=6c57bced"
import script from "./CarSizeTypeView.vue?vue&type=script&lang=js"
export * from "./CarSizeTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports